import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';

const AdminRoute = ({ children, redirectTo = "/" }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    gap: 2
                }}
            >
                <CircularProgress size={60} sx={{ color: '#43a047' }} />
                <Typography variant="h6" color="text.secondary">
                    Verifying admin access...
                </Typography>
            </Box>
        );
    }

    // Check if user is authenticated and has admin role
    const isAdmin = user && (user.role === 'ADMIN' || user.role === 'SUPER_ADMIN');

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (!isAdmin) {
        return <Navigate to={redirectTo} replace />;
    }

    return children;
};

export default AdminRoute;
